module.exports = __webpack_public_path__ + "static/media/CronosPro-Regular.13fc4e17.ttf";